<template>
  <div class="notice">
    <div class="warning" v-if="!isThree && platformUpdateStatus"><i></i>{{platformUpdateInfo}}</div>
    <div class="warning" v-if="isSign === null && isName === null">
      <i></i>{{$t('notice_title1')}}
      <router-link to="/WorkBench/AccountSetting/Home"> {{$t('notice_title3_')}} </router-link>
    </div>
    <div class="warning" v-if="isName === -1">
      <i></i>{{$t('notice_title9')}}
      <router-link to="/WorkBench/AccountSetting/NameApprove">{{$t('notice_title2')}}</router-link>
    </div>
    <div class="warning" v-if="isSign === 2 && isName !== -1">
      <i></i>{{$t('notice_title3')}}
      <router-link to="/WorkBench/AccountSetting/AgreementApprove">{{$t('notice_title2')}}</router-link>
    </div>
  </div>
</template>

<script>
import {
  abkLink,
  abkManageLink
} from 'assets/scripts/common';
import {
  getNotice,
  getSettlement,
  getSignature,
  getRealName,
  getNameApproveInfo
} from 'http/api/default';

export default {

  data () {
    return {
      platformUpdateStatus: false,
      platformUpdateInfo: '',
      isSign: '',
      isName: null,
      settlementNoticeStatus: false,
      isThree: this.$store.state.app.isTripartite,
    }
  },
  watch: {
    $route (val) {
      if (this.$route.path === '/open/default') {
        this.getSettlement()
        this.getRealName()
        this.getNotice();
        this.getSignature();
        this.getNameApproveInfo();
      }
    }

  },
  methods: {
    abkLink: function () {
      return abkLink();
    },
    abkManageLink: function () {
      return abkManageLink();
    },
    getSettlement: function () {
      var self = this;
      getSettlement().then(function (res) {
        if (res.rt.status === 200) {
          if (res.data > 0) {
            self.openModal1();
          } else {
            self.settlementNoticeStatus = false;
          }
        }
      });
    },
    openModal1: function () {
      var self = this;
      this.$Modal.confirm({
        title: self.$t('notice_title4'),
        content: self.$t('notice_title7'),
        okText: self.$t('notice_title5'),
        cancelText: self.$t('notice_title6'),
        onOk: function () {
          // window.open(self.abkLink() + '/manager/index/integral/manage');
          window.open('/managerv4/home/taskManage/settlementManage/settlement');
        }
      });
    },
    openModal2: function () {
      var self = this;
      this.$Modal.confirm({
        title: self.$t('notice_title4'),
        content: self.$t('notice_title8'),
        okText: self.$t('notice_title5'),
        cancelText: self.$t('notice_title6'),
        onOk: function () {
          self.$router.push('/WorkBench/AccountSetting/Home');
        }
      });
    },
    getNotice: function () {
      var self = this;
      getNotice().then(function (res) {
        // console.log(res)
        if (res.rt.status === 200) {
          self.platformUpdateStatus = res.data.isShow;
          self.platformUpdateInfo = res.data.content;
        }
      });
    },
    getSignature: function () {
      var self = this;
      getSignature().then(function (res) {
        self.isSign = res.data ? res.data.status : res.data
      });
    },

    getNameApproveInfo () {
      var self = this;
      getNameApproveInfo().then(function (res) {
        if (res.data && res.data[0]) {
          self.isName = res.data[0].status;
        }
        console.log(self.isName)
      });
    },

    getRealName: function () {
      var self = this;
      getRealName().then(function (res) {
        if (res.rt.status === 200) {
          if (res.data) {
            self.openModal2();
          }
        } else {
          self.$Message.info(res.data);
        }
      });
    }

  },
  mounted () {
    if (this.$route.path === '/open/default') {
      this.getSettlement()
      this.getRealName()
      // this.getNotice();
      this.getSignature();
      this.getNameApproveInfo();
    }
    this.getNotice();
    // this.getSignature();
    // this.getNameApproveInfo();
  }
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import "../../assets/theme/themeBlue.less";

  .warning {
    display: block;
    width: 100%;
    min-height: 30px;
    line-height: 30px;
    background: #FFFBE6;
    border-bottom: 1px solid #eee;
    text-align: center;
    position: relative;
    z-index: 1013;
  }

  .warning i {
    display: inline-block;
    width: 20px;
    height: 20px;
    position: relative;
    top: 4px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAACaElEQVQ4T62UTUgUcRjGn3eUBUOLStmZYGdm6eDOWFBYh8I6RERCJWldC9SLdAqjj0MnD0b0cSsqI7qFl+xQIFT06aFLYTnjHqKdNZrZAhFDs2jniV1ZG3cXQmguf3je5/393/fP+47gP31SjTM1sXodpW4fgBaKWAQaBbIgxKhw7m6iZXa6PK8ClHHivRC5DOI1RIZqwOlQ0AhKK8EdALaC7Dft3FAUtgyUdeIDhHJCavLdevPXkWrVZlytU4hbFN4xreBUybMEyrhaF8BrsZiyfcPGL9mSwUs3tQlqRW/2X5Y031XNn8AbAa8aVm6woBdB3yYbG+ZY+1FRpCuaUIh5rvq+cBpWsDla4VRabQ/zGA7rFhLJ5MxMEZSdVPtI6TAsf395OxlXmyxopuWnKmKO9lZReFNPBdeLIM9VHwjkuW75V1YC8hz1NARthhUcWgQ56gcCZ0w7eLgikBs/CMqgYQebShWNkzhr2sGjSpD6DJRp0/Y7y2OeGz8AyoW/IEcbAThm2MHFcnNhOH+vmp1PJrFQ5ZJ+IdoNO9gbfexew/Jby82f3Yb1rP8+n0jgR2VF2ijJV6YdDCy25q1Zy/k6T4Ec1S1/NJrgOepjCGYMKziyTE83tTFf+wRKmDJTuU9LA+m58XOEnIzFlG3RgcymtV3IQ3Tbf1E+kAp5Q7dz55cGsmTIuOoloXQrQE/C9u9XXWhHOxwCtykcN1LBHhGEFaCCkHHiPcWlBd4JZEwYjgMgRdkCcidEdhO8Z4TBcWnBr4pdi95eeOCQ9cdCYYdQSqsxAQkdCobNVO5pebVV/0fVWvqX9gf7twoilFvWLQAAAABJRU5ErkJggg==) no-repeat center center;
  }
</style>
